"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidGridElement = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const framer_motion_1 = require("framer-motion");
const react_1 = require("react");
const components_1 = require("./components");
const eventVariants = {
    hidden: {
        opacity: 0,
    },
    inView: {
        opacity: 1,
        y: [50, 0],
    },
};
function FluidGridElement({ index, select, data, element: Element, }) {
    const { scrollY } = (0, framer_motion_1.useScroll)();
    const isMobile = (0, app_1.useIsMobile)();
    const y = (0, framer_motion_1.useTransform)(scrollY, [-100, 200], [0, -10 - Math.floor(Math.random() * 5)], {
        clamp: false,
    });
    const even = (0, react_1.useMemo)(() => index % 2, [index]);
    return ((0, jsx_runtime_1.jsx)(components_1.Item, Object.assign({ noCenter: true, "$row": index * 3 + 1 }, { children: (0, jsx_runtime_1.jsx)(components_1.MotionFade, Object.assign({ initial: "hidden", whileInView: "inView", variants: eventVariants, style: { marginLeft: even ? 'auto' : 0 }, transition: { duration: 1 }, viewport: { once: true }, onClick: () => select(data.id) }, { children: (0, jsx_runtime_1.jsx)(components_1.MotionParallax, Object.assign({ style: { y: isMobile ? 0 : y } }, { children: (0, jsx_runtime_1.jsx)(Element, Object.assign({}, data)) })) })) }), index));
}
exports.FluidGridElement = FluidGridElement;
